import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Card, HiristBanner, BannerInfo} from '@jobseeker/lotus/components';
import {Paragraph} from '@jobseeker/lotus/elements';
import {Link} from '@mui/material';
import HomePageFooter from '@components/HomeV2/homePageFooter';
import {TermsAndConditionIcon, CheckV2} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';

type TermsProps = {
  isMobile?: boolean;
};

const TermsPage = ({isMobile}: TermsProps) => {
  const theme = useWrappedTheme();
  const DOMAIN = process.env.NEXT_PUBLIC_APP_DOMAIN;
  const DOMAIN2 =
    process.env.NEXT_PUBLIC_APP_DOMAIN === 'iimjobs.com'
      ? 'iimjobs.com'
      : 'Hirist.tech';
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  const recruiterTeamsContent = (
    <>
      <li>
        You will comply with all applicable data protection laws in relation to
        the processing of personal data, and not process personal data in an
        unlawful manner and excessive with regard to agreed purposes as defined
        in the privacy policy and these terms and conditions.
      </li>
      <li>
        You shall implement adequate technical and organizational controls to
        protect the shared personal data obtained from the Company against
        unauthorized or unlawful processing and against accidental loss,
        destruction, damage, alteration, or disclosure.
      </li>
      <li>
        You agree to provide reasonable assistance as is necessary to facilitate
        the handling of any Data Security Breach (as relevant under privacy laws
        applicable) in an expeditious and compliant manner.
      </li>
      <li>
        You agree that the responsibility for complying with a data subject
        /data principal request lies with the Party which holds/processes the
        Personal Data collected/shared.
      </li>
      <li>
        You warrant and represent that the institution shall not disclose or
        transfer Personal Data obtained from the Company to any sub-processors
        without ensuring that adequate and equivalent safeguards to the Personal
        Data.
      </li>
      <li>
        You shall retain or process shared Personal Data for no longer than is
        necessary to carry out the agreed purposes.
      </li>
      <li>
        You shall act as an independent Data Controller in respect of shared
        personal data obtained from the Company once the data is collected by
        You and You shall be responsible for its secure use at all times.
      </li>
      <li>
        Any product or service purchased from Info Edge (India) Limited cannot
        be refunded or exchanged for any {DOMAIN} products or any other products
        falling under the umbrella of Info Edge Pvt. Ltd.
      </li>
    </>
  );
  const basicPostingContent = (
    <>
      <li>
        Recruiters can post free Jobs for which they are currently seeking
        Candidates and Candidates may filter and search through various Jobs
        posted on the platform and apply to those Jobs.&nbsp;
      </li>
      <li>
        By using Free Postings, you hereby acknowledge and agree that your use
        of the Free Postings is subject to limitations that we may impose from
        time-to-time in our sole discretion, including, by way of example,
        limitations on the number of Jobs that you may post, or limitations on
        your ability to access and use certain features and functionalities of
        the Free Postings. We also hereby reserve the right to modify or
        discontinue your access to Free Postings at any time for any reason.
      </li>
      <li>
        Info Edge (India) Limited reserves its right to reject any insertion or
        information/data provided by the recruiter without assigning any reason
        either before uploading or after uploading the job details.&nbsp;
      </li>
      <li>
        By posting/uploading a job posting on the website you confirm that you
        have obtained all licenses/permits as are necessary for recruitment and
        to indemnify Info Edge (India) Limited against all claims, damages
        arising out of actions/claims that may be made in relation to the same.
      </li>
      <li>
        Info Edge (India) Limited has the right to make all such
        modifications/editing of the vacancy details in order to fit its
        database.
      </li>
      {isAppIimjobs && (
        <li>
          All information intimated by the recruiter and displayed by Info Edge
          (India) Limited on {DOMAIN} becomes public knowledge and Info Edge
          (India) Limited may at its sole discretion include the vacancy
          intimated by a recruiter for display on {DOMAIN} in any other media
          including, but not limited to the print media at no extra costs to the
          recruiter and Info Edge (India) Limited shall not be held liable for
          usage/publicity of such information.
        </li>
      )}
      <li>
        Info Edge (India) Limited offers no guarantee nor warranties that there
        would be a satisfactory response or any at all response once the job is
        put on display.
      </li>
      <li>
        Info Edge (India) Limited shall in no way be held liable for any
        information received by the recruiter and it shall be the sole
        responsibility of the recruiter to check, authenticate and verify the
        information/response received at its own cost and expense.
      </li>
      <li>
        Info Edge (India) Limited would not be held liable for any loss of data,
        technical or otherwise, information, particulars supplied by the
        recruiter, due to the reasons beyond its control like corruption of data
        or delay or failure to perform as a result of any causes or conditions
        that are beyond Info Edge (India) Limited&apos;s reasonable control
        including but not limited to strike, riots, civil unrest, Govt.
        policies, tampering of data by unauthorized persons like hackers, war
        and natural calamities.
      </li>
      <li>
        Recruiter shall be deemed to give an undertaking to Info Edge (India)
        Limited that the jobs posted on {DOMAIN} are in existence, are genuine,
        and that the recruiter has the authority to advertise for such jobs.
      </li>
      <li>
        Recruiter must give an undertaking to Info Edge (India) Limited that
        there will be no fee charged from any person who responds to or applies
        to jobs posted on {DOMAIN} for processing of applications/responses from
        such person.
      </li>
      <li>
        Info Edge (India) Limited reserves its right to change the look, feel,
        design, prominence, depiction, classification of the jobs posted on{' '}
        {DOMAIN} at any time without assigning any reason and without giving any
        notice.
      </li>
      <li>
        Recruiter can register on {DOMAIN} to post a job and the sole
        responsibility of the safe custody of the password and other details
        shall be that of the recruiter and Info Edge (India) Limited shall not
        be responsible for data loss/theft of data/corruption of data or the
        wrong usage/misuse of the password and any damage or leak of information
        and its consequential usage by a third party. Info Edge (India) Limited
        undertakes to take all reasonable precautions at its end to ensure that
        there is no leakage/misuse of the data provided by the recruiter
      </li>
      <li>
        The User of these services does not claim any copyright or other
        Intellectual Property Right over the data uploaded by him/her on the
        website
      </li>
      <li>
        All disputes arising out of the transactions between a user and Info
        Edge (India) Limited will be resolved in accordance with the laws of
        India as applicable.
      </li>
    </>
  );
  const signaturePosting = (
    <>
      <li>
        Recruiters can post Signature/Premium Jobs by purchasing Premium Credits
        (“Credits”) for which they are currently seeking Candidates and
        Candidates may filter and search through various Jobs posted on the
        platform and apply to those Jobs.
      </li>
      <li>
        All Credits are valid for a limited time as described in the applicable
        terms and conditions. Credits expire immediately once the validity is
        over.
      </li>
      <li>
        To post a job as Signature/Premium Posting, one Credit is deducted from
        your account. All the benefits associated with a Signature/Premium
        Posting on {DOMAIN} are valid for a fixed period (currently 15 days),
        after which it converts to a Basic/Free Posting. This period is subject
        to change, however, any such change will be communicated to recruiters.
      </li>
      <li>
        Every instance of marking an existing listing as Signature/Premium Job
        requires you to use 1 Credit and you will be entitled to an additional
        fixed period (currently 15 days) starting from the date on which the
        listing is marked.
      </li>
      <li>
        If a Recruiter wants to make any job as Signature/Premium Posting again,
        they can do so by using another Credit.
      </li>
      <li>
        Credits once purchased cannot be refunded or exchanged for any {DOMAIN}{' '}
        products or any other products falling under the umbrella of Info Edge
        Pvt. Ltd.
      </li>
      <li>
        Refund (if any) will be at the sole discretion of Info Edge (India)
        Limited. Refunds (if any) shall be processed within 7-8 days from the
        date of such cancellation to the original source of your payment. Info
        Edge (India) Limited offers no guarantees whatsoever for the accuracy or
        timeliness of the refunds reaching the Customers card/bank accounts.
        Info Edge (India) Limited gives no guarantees of server uptime or
        applications working properly. All is on a best effort basis and
        liability is limited to refund of amount only.
      </li>
      <li>
        Info Edge (India) Limited agrees to provide the service to the recruiter
        only for the duration contracted for to the best of its ability
      </li>
      <li>
        Info Edge (India) Limited reserves its right to suspend/terminate the
        services contracted for by the recruiter either prior to or during the
        contracted period without assigning any reason. In such an eventuality,
        any amount so paid for by the recruiter for this service, may be
        refunded by Info Edge (India) Limited on a pro-rata basis to the
        recruiter at its discretion.
      </li>
      <li>
        Info Edge (India) Limited reserves its right to reject any insertion or
        information/data provided by the recruiter without assigning any reason
        either before uploading or after uploading the job details, but in such
        an eventuality, any amount so paid for, may be refunded to the recruiter
        on a pro-rata basis at the sole discretion of Info Edge (India) Limited.
      </li>
      <li>
        By posting/uploading a job posting on the website you confirm that you
        have obtained all licenses/permits as are necessary for recruitment and
        to indemnify Info Edge (India) Limited against all claims, damages
        arising out of actions/claims that may be made in relation to the same.
      </li>
      <li>
        Info Edge (India) Limited has the right to make all such
        modifications/editing of the vacancy details in order to fit its
        database.
      </li>
      <li>
        All information intimated by the recruiter and displayed by Info Edge
        (India) Limited on {DOMAIN} becomes public knowledge and Info Edge
        (India) Limited may at its sole discretion include the vacancy intimated
        by a recruiter for display on {DOMAIN} in any other media including, but
        not limited to the print media at no extra costs to the recruiter and
        Info Edge (India) Limited shall not be held liable for usage/publicity
        of such information.
      </li>
      <li>
        Info Edge (India) Limited offers no guarantee nor warranties that there
        would be a satisfactory response or any at all response once the job is
        put on display.
      </li>
      <li>
        Info Edge (India) Limited shall in no way be held liable for any
        information received by the recruiter and it shall be the sole
        responsibility of the recruiter to check, authenticate and verify the
        information/response received at its own cost and expense.
      </li>
      <li>
        Info Edge (India) Limited would not be held liable for any loss of data,
        technical or otherwise, information, particulars supplied by the
        recruiter, due to the reasons beyond its control like corruption of data
        or delay or failure to perform as a result of any causes or conditions
        that are beyond Info Edge (India) Limited&apos;s reasonable control
        including but not limited to strike, riots, civil unrest, Govt.
        policies, tampering of data by unauthorized persons like hackers, war
        and natural calamities
      </li>
      <li>
        Info Edge (India) Limited will commence providing services only upon
        receipt of amount/charges upfront either from the recruiter or from a
        third party on behalf of the recruiter.
      </li>
      <li>
        Recruiter shall be deemed to give an undertaking to Info Edge (India)
        Limited that the jobs posted on {DOMAIN} are in existence, are genuine,
        and that the recruiter has the authority to advertise for such jobs.
      </li>
      <li>
        Recruiter must give an undertaking to Info Edge (India) Limited that
        there will be no fee charged from any person who responds to or applies
        to jobs posted on {DOMAIN} for processing of applications/responses from
        such person.
      </li>
      <li>
        Info Edge (India) Limited reserves its right to change the look, feel,
        design, prominence, depiction, classification of the jobs posted on{' '}
        {DOMAIN} at any time without assigning any reason and without giving any
        notice.
      </li>
      <li>
        The Signature/Premium Posting is neither re-saleable nor transferable by
        the recruiter to any other person, corporate body, firm, or individual.
        Usage from third party premises/networks without prior written
        permission of Info Edge (India) Limited is not permitted.
      </li>
      <li>
        Recruiter can register on {DOMAIN} to post a job and the sole
        responsibility of the safe custody of the password and other details
        shall be that of the recruiter and Info Edge (India) Limited shall not
        be responsible for data loss/theft of data/corruption of data or the
        wrong usage/misuse of the password and any damage or leak of information
        and its consequential usage by a third party. Info Edge (India) Limited
        undertakes to take all reasonable precautions at its end to ensure that
        there is no leakage/misuse of the data provided by the recruiter.
      </li>
      <li>
        The User of these services does not claim any copyright or other
        Intellectual Property Rights over the data uploaded by him/her on the
        website.
      </li>
      <li>
        All disputes arising out of the transactions between a user and Info
        Edge (India) Limited will be resolved in accordance with the laws of
        India as applicable.
      </li>
    </>
  );
  const resdexContent = (
    <>
      <li>
        Info Edge (India) Limited agrees to provide the service to the
        subscriber only for the duration contracted for to the best of its
        ability&nbsp;
      </li>
      <li>
        Info Edge (India) Limited reserves its right to suspend/terminate the
        services contracted for by the subscriber either prior to or during the
        contracted period without assigning any reason. In such an eventuality,
        any amount so paid for by the subscriber for this service, may be
        refunded by Info Edge (India) Limited at a pro-rata basis to the
        subscriber at its discretion. 2A. The subscriber shall be entitled to 1
        user name/password to access the Resdex/Database Search service alone
        and additional user names/passwords may be provided by Info Edge (India)
        Limited on such terms and conditions as may be mutually agreed
        upon.&nbsp;
      </li>
      <li>
        Info Edge (India) Limited offers no guarantee nor warranties that there
        would be a satisfactory response or any response at all subscriber for
        applications received/profiles shown using the Resdex/Database Search
        software.&nbsp;
      </li>
      <li>
        Info Edge (India) Limited shall in no way be held liable for any
        information received by the subscriber and it shall be the sole
        responsibility of the subscriber to check, authenticate and verify the
        information/response received at its own cost and expense.&nbsp;
      </li>
      <li>
        Any actions taken by an employer/recruiter on the basis of the
        background check report or otherwise, is the
        employer&apos;s/recruiter&apos;s responsibility alone and Info Edge
        (India) Limited will not be liable in any manner for the consequences of
        such action taken by the user.
      </li>
      <li>
        Info Edge (India) Limited would not be held liable for any loss of data
        technical or otherwise, information, particulars supplied by the
        customers due to the reasons beyond its control like corruption of data
        or delay or failure to perform as a result of any causes or conditions
        that are beyond Info Edge&apos;s reasonable control including but not
        limited to strike, riots, civil unrest, Govt. policies, tampering of
        data by unauthorized persons like hackers, war and natural
        calamities.&nbsp;
      </li>
      <li>
        Only the activities performed in the last 365 days on a profile mapped
        to a Resdex/Database Search Requirement will be retained. The older
        activities shall be automatically deleted. For the purposes of this
        clause, Resdex/Database Search Requirements include, but is not limited
        to activities including profile viewed, downloaded, emailed, and added
        to folder.&nbsp;
      </li>
      {isAppIimjobs && (
        <li>
          Info Edge (India) Limited will commence providing services only upon
          receipt of amount/charges upfront either from the subscriber or from a
          third party on behalf of the subscriber.&nbsp;
        </li>
      )}
      <li>
        The subscriber/Recruiter
        <br />
        i. shall give an undertaking to Info Edge (India) Limited that the jobs
        sought to be filled through {DOMAIN} are in existence, genuine and the
        subscriber has the authority to recruit /advertise for such vacancies.
        Also, the subscriber undertakes that the database will be used to
        contact candidates for jobs only <br />
        ii. shall ensure compliance with all applicable laws for the protection
        of the personal details of the users whose profiles are accessed by them
        through {DOMAIN} including but not limited to compliance with the
        Telecom Commercial Communications Customer Preference Regulations, 2010
        as also rules, regulations, guidelines, bye-laws and notifications made
        there under, while accessing or feeding any resume/ insertion or
        information/data into the computers, computer systems or computer
        networks of Info Edge (India) Limited.
      </li>
      <li>
        Info Edge (India) Limited reserves its right to change the look, feel,
        design, prominence, depiction, classification of any section of {DOMAIN}{' '}
        at any time without assigning any reason and without giving any
        notice.&nbsp;
      </li>
      <li>
        The subscriber/Recruiter must give an undertaking to Info Edge that
        there will be no fee charged from any person who is contacted through
        Resdex/Database Search for processing of such a person.&nbsp;
      </li>
      <li>
        This subscription is neither re-saleable nor transferable by the
        subscriber to any other person, corporate body, firm, or individual
        concern&nbsp;
      </li>
      <li>
        The subscriber shall be assigned a password (s) by Info Edge (India)
        Limited to enable the subscriber to access all the information received
        through the software, but the sole responsibility of the safe custody of
        the password shall be that of the subscriber and Info Edge (India)
        Limited shall not be responsible for data loss/theft of data/corruption
        of data or the wrong usage/misuse of the password and any damage or leak
        of information and its consequential usage by a third party.Info Edge
        (India) Limited undertakes to take all reasonable precautions at its end
        to ensure that there is no leakage/misuse of the password granted to the
        subscriber.&nbsp;
      </li>
      <li>
        The information on Info Edge (India) Limited is for use by its
        subscribers alone and does not authorize the subscriber to download and
        use the data for commercial purposes. In case anyone is found to be in
        violation of this, then Info Edge (India) Limited at its discretion may
        suspend its service/subscription and also may take such action as it may
        be advised.&nbsp;
      </li>
      <li>
        The subscriber shall not use/circulate/forward a person&apos;s resume
        hosted on the Info Edge (India) Limited Network / Resumes to his / her
        current employer as mentioned by the person in his / her resume.&nbsp;
      </li>
      <li>
        The User of these services does not claim any copyright or other
        Intellectual Property Rights over the data uploaded by him or on his
        behalf on the website or supplied to Info Edge (India) Limited.
      </li>
    </>
  );
  return (
    <Box>
      {!isAppIimjobs && (
        <HiristBanner>
          <BannerInfo
            Icon={TermsAndConditionIcon}
            isMobile={!!isMobile}
            subTitle={'Terms and Conditions'}
            title={''}
          />
        </HiristBanner>
      )}
      <Box
        sx={{
          maxWidth: '1340px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mx: isAppIimjobs
            ? {lg: '195px'}
            : {xxs: '10px', md: '30px', lg: '50px'},
          my: isAppIimjobs ? '0px' : {xxs: '12px', sm: '12px', md: '40px'},
        }}
      >
        <Card
          variant=""
          heading=""
          sx={{
            px: !isAppIimjobs ? {xxs: '12px', xs: '12px', sm: '20px'} : '',
            py: !isAppIimjobs ? {xxs: '13px', xs: '13px', sm: '20px'} : '',
          }}
        >
          {isAppIimjobs && (
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontSize: '24px',
                fontWeight: 500,
                lineHeight: '30px',
                textAlign: 'Center',
                color: 'secondary.dark',
                marginBottom: '40px',
              }}
            >
              TERMS AND CONDITIONS
            </Typography>
          )}

          <Paragraph
            style={
              !isAppIimjobs && {
                fontSize: '15px',

                lineHeight: '24px',
              }
            }
            title="PURPOSE:"
            titleStyle={
              !isAppIimjobs && {
                fontSize: '15px',
              }
            }
            body={
              <Box display="flex" gap="8px">
                <Box>
                  {DOMAIN2} is intended only to serve as a preliminary medium of
                  contact and exchange of information for its users / members /
                  visitors who have a bona fide intention to contact and/or be
                  contacted for the purposes related to genuine existing job
                  vacancies and for other career enhancement services.
                </Box>
              </Box>
            }
          />
          <Paragraph
            style={
              !isAppIimjobs && {
                fontSize: '15px',

                lineHeight: '24px',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '15px',
                fontWeight: 'bold',
              }
            }
            title="USE TO BE IN CONFORMITY WITH THE PURPOSE"
            body={
              <>
                {DOMAIN2} (and related products) or service or product that is
                subscribe to or used (whether the same is paid for by you or
                not) is meant for the Purpose and only the exclusive use of the
                subscriber/registered user. Copying or downloading or recreating
                or sharing passwords or sublicensing or sharing in any manner
                which is not in accordance with these terms, is a misuse of the
                platform or service or product and IEIL reserves its rights to
                act in such manner as to protect its loss of revenue or
                reputation or claim damages including stopping your service or
                access and reporting to relevant authorities. In the event you
                are found to be copying or misusing or transmitting or crawling
                any data or photographs or graphics or any information available
                on {DOMAIN2} for any purpose other than that being a Bonafide
                Purpose, we reserve the right to take such action that we deem
                fit including stopping access and claiming damages.
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',
                      lineHeight: '24px',
                      margin: '10px 0px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The site is a public site with free access and Info Edge
                      (India) Limited assumes no liability for the quality and
                      genuineness of responses. Info Edge (India) Limited cannot
                      monitor the responses that a person may receive in
                      response to information he/she has displayed on the site.
                      The individual/company would have to conduct their own
                      background checks on the bonafide nature of all
                      response(s).
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Info Edge (India) Limited will not be liable on account of
                      any inaccuracy of information on this web site. It is the
                      responsibility of the visitor to further research the
                      information on the site. Any breach of privacy or of the
                      information provided by the consumer to Info Edge (India)
                      Limited to be placed on the website by technical or any
                      other means is not the responsibility of Info Edge (India)
                      Limited. Info Edge (India) Limited does not guarantee
                      confidentiality of information provided to it by any
                      person acquiring/using all/any information displayed on
                      the {DOMAIN} website or any of its other websites /
                      domains owned and operated by Info Edge (India) Limited.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Info Edge (India) Limited does not share personally
                      identifiable data of any individual with other companies /
                      entities without obtaining permission except with those
                      acting as our agents. Info Edge (India) Limited shall
                      share all such information that it has in its possession
                      in response to legal process, such as a court order or
                      subpoena. The user shall not utilize the services offered
                      by {DOMAIN} in any manner so as to impair the interests
                      and functioning of {DOMAIN}. The user undertakes not to
                      duplicate, download publish, modify and distribute
                      material on {DOMAIN} unless specifically authorized by
                      Info Edge (India) Limited in this regard. The user
                      undertakes not to establish any deep link or other
                      connection to any specific page of {DOMAIN} other than the
                      Home Page without obtaining prior consent of Info Edge
                      (India) Limited.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The user undertakes to use {DOMAIN} for his/her own
                      purposes. Using content from {DOMAIN} for derivative works
                      with a commercial motive without prior written consent
                      from Info Edge (India) Limited is strictly prohibited.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      {DOMAIN} uses technological means to exclude Robots etc
                      from crawling the website and scraping content. The user
                      undertakes not to circumvent these methods.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Users undertake that the services offered by {DOMAIN}{' '}
                      shall not be utilized to upload, post, email, transmit or
                      otherwise make available either directly or indirectly,
                      any unsolicited bulk e-mail or unsolicited commercial
                      e-mail. Info Edge (India) Limited reserves the right to
                      filter and monitor and block the emails sent by you/user
                      using the servers maintained by Info Edge (India) Limited
                      to relay emails. All attempts shall be made by Info Edge
                      (India) Limited and the user to abide by International
                      Best Practices in containing and eliminating Spam.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Users shall not spam the database maintained by {DOMAIN}{' '}
                      or indiscriminately and repeatedly forward mail that may
                      be considered spam etc. etc. Any conduct of the user in
                      violation of this clause shall entitle Info Edge (India)
                      Limited to forthwith terminate all services to the user
                      without notice and to forfeit any amounts paid by him.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The user shall not upload, post, transmit, publish, or
                      distribute any material or information that is unlawful,
                      or which may potentially be perceived as being harmful,
                      threatening, abusive, harassing, defamatory, libelous,
                      vulgar, obscene, or racially, ethnically, or otherwise
                      objectionable.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The user expressly states that the resume/insertion or
                      information/ data being fed into the network of Info Edge
                      (India) Limited by the user is correct and complete in all
                      respects and does not contain any false, distorted,
                      manipulated, fraudulent or misleading facts or averments.
                      Info Edge (India) Limited expressly disclaims any
                      liability arising out of the said resume
                      insertion/information/ data so fed into the network of
                      Info Edge (India) Limited by the user. Further, the user
                      agrees to indemnify Info Edge (India) Limited for all
                      losses incurred by Info Edge (India) Limited due to any
                      false, distorted, manipulated, defamatory, libelous,
                      vulgar, obscene, fraudulent or misleading facts or
                      otherwise objectionable averments made by the user on the
                      network of Info Edge (India) Limited.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The User is solely responsible for maintaining
                      confidentiality of the User password and user
                      identification and all activities and transmission
                      performed by the User through his user identification and
                      shall be solely responsible for carrying out any online or
                      off-line transaction involving credit cards / debit cards
                      or such other forms of instruments or documents for making
                      such transactions and Info Edge (India) Limited assumes no
                      responsibility or liability for their improper use of
                      information relating to such usage of credit cards / debit
                      cards used by the subscriber online / off-line.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The User/Subscriber/Visitor to {DOMAIN} and/or its
                      affiliated websites does hereby specifically agree that
                      he/she shall, at all times, comply with the requirements
                      of the Information Technology Act, 2000 as also rules,
                      regulations, guidelines, bye laws and notifications made
                      thereunder, while assessing or feeding any resume/
                      insertion or information/data into the computers, computer
                      systems or computer network of Info Edge (India) Limited.
                      The said User/ subscriber/ visitor to {DOMAIN} and/or its
                      affiliated websites does further unequivocally declare
                      that in case he violates any provisions of the Information
                      Technology Act, 2000 and/or rules, regulations,
                      guidelines, byelaws and notifications made thereunder, he
                      shall alone be responsible for all his acts, deeds and
                      things and that he alone shall be liable for civil and
                      criminal liability there under or under any other law for
                      the time being in force.
                    </Box>
                  }
                />
                <Box display="flex">
                  {!isAppIimjobs && (
                    <Box
                      sx={{
                        pt: 0.5,
                        pr: 1,
                      }}
                    >
                      <Image
                        src={CheckV2}
                        alt="banner-icon"
                        width={20}
                        height={20}
                      />
                    </Box>
                  )}
                  The User is solely responsible for obtaining, at his own cost,
                  all licenses, permits, consents, approvals and intellectual
                  property or other rights as may be required by the user for
                  using the Service.
                </Box>
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <>
                      <Box display="flex">
                        {!isAppIimjobs && (
                          <Box
                            sx={{
                              pt: 0.5,
                              pr: 1,
                            }}
                          >
                            <Image
                              src={CheckV2}
                              alt="banner-icon"
                              width={20}
                              height={20}
                            />
                          </Box>
                        )}
                        The User / subscriber / visitor to {DOMAIN} or
                        affiliated site(s) are prohibited from uploading,
                        posting, transmitting, updating or sharing: any
                        information that:
                      </Box>
                      <Box>
                        <Box
                          component={'ul'}
                          sx={{
                            // listStyleType: 'lower-roman',
                            li: {
                              mt: 0,
                              '::marker': {
                                color: isAppIimjobs
                                  ? 'none'
                                  : theme.palette.primary.main,
                              },
                            },
                          }}
                        >
                          <li>
                            belongs to another person and to which the user does
                            not have any right to;
                          </li>
                          <li>
                            is grossly harmful, harassing, blasphemous,
                            defamatory, obscene, pornographic, pedophilic,
                            libelous, invasive of another&apos;s privacy,
                            hateful, or racially, ethnically objectionable,
                            disparaging, relating or encouraging money
                            laundering or gambling, or otherwise unlawful in any
                            manner whatever; harm minors in any way;
                          </li>
                          <li>
                            infringes any patent, trademark, copyright or other
                            proprietary rights;
                          </li>
                          <li>violates any law for the time being in force;</li>
                          <li>
                            deceives or misleads the addressee about the origin
                            of such messages or communicates any information
                            which is grossly offensive or menacing in nature;
                            impersonate another person;
                          </li>
                          <li>
                            contains software viruses or any other computer
                            code, files or programs designed to interrupt,
                            destroy or limit the functionality of any computer
                            resource; threatens the unity, integrity, defense,
                            security or sovereignty of India, friendly relations
                            with foreign states, or or public order or causes
                            incitement to the commission of any cognizable
                            offence or prevents investigation of any offence or
                            is insulting any other nation.
                          </li>
                        </Box>
                        <Box display="flex">
                          {!isAppIimjobs && (
                            <Box
                              sx={{
                                pt: 0.5,
                                pr: 1,
                              }}
                            >
                              <Image
                                src={CheckV2}
                                alt="banner-icon"
                                width={20}
                                height={20}
                              />
                            </Box>
                          )}
                          The user shall not infringe on any intellectual
                          property rights of any person / entity or retain
                          information / download any information from any
                          computer system or otherwise with an intention to do
                          so.
                        </Box>
                      </Box>
                    </>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Info Edge (India) Limited will make best efforts to do so
                      but does not warrant that any of the web sites or any
                      affiliate site(s) or network system linked to it is free
                      of any operational errors nor does it warrant that it will
                      be free of any virus, computer contaminant, worm, or other
                      harmful components. The subscription of a user shall be
                      subject to Quotas as applicable and as advised. E-Mails
                      provided as part of contact details are expected to be
                      genuine and access to such email accounts is available to
                      authorized personnel only.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Info Edge (India) Limited shall not be liable for any loss
                      or damage sustained by reason of any disclosure
                      (inadvertent or otherwise) of any information concerning
                      the user&apos;s account and / or information relating to
                      or regarding online transactions using credit cards /
                      debit cards and / or their verification process and
                      particulars nor for any error, omission or inaccuracy with
                      respect to any information so disclosed and used whether
                      or not in pursuance of a legal process or otherwise.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <>
                      <Box display="flex">
                        {!isAppIimjobs && (
                          <Box
                            sx={{
                              pt: 0.5,
                              pr: 1,
                            }}
                          >
                            <Image
                              src={CheckV2}
                              alt="banner-icon"
                              width={20}
                              height={20}
                            />
                          </Box>
                        )}
                        Payments for the services offered by {DOMAIN} shall be
                        on a 100% advance basis. Refund if any will be at the
                        sole discretion of Info Edge (India) Limited.{' '}
                        {!isAppIimjobs &&
                          'Refunds (if any) shall be processed within 7-8 days from the date of such cancellation to the original source of your payment.'}{' '}
                        Info Edge (India) Limited offers no guarantees
                        whatsoever for the accuracy or timeliness of the refunds
                        reaching the Customers card/bank accounts. Info Edge
                        (India) Limited gives no guarantees of server uptime or
                        applications working properly. All is on a best effort
                        basis and liability is limited to refund of amount only.
                        Info Edge (India) Limited undertakes no liability for
                        free services. Info Edge (India) Limited reserves its
                        right to amend / alter or change all or any disclaimers
                        or terms of agreements at any time without any prior
                        notice. All terms / disclaimers whether specifically
                        mentioned or not shall be deemed to be included if any
                        reference is made to them.
                      </Box>
                      <Box sx={{mt: 1.5, ml: isAppIimjobs ? 0 : 3.5}}>
                        Where the <i>bill-to</i>, <i>ship-to</i>, and/or{' '}
                        <i>paying</i> customer are different entities (for the
                        purposes of this clause collectively, the “Customers”),
                        each Customer jointly and severally represents and
                        warrants that they have a valid and lawful internal
                        arrangement authorizing their engagement with Info Edge
                        (India) Limited (“Company”). Each Customer agrees to
                        fully indemnify and hold the Company harmless from any
                        claims or liabilities arising from such inter-se
                        arrangements.
                      </Box>
                      <Box sx={{mt: 1.5, ml: isAppIimjobs ? 0 : 3.5}}>
                        Each Customer shall promptly provide all required KYC
                        documents of any or all Customers upon the Company’s
                        request.
                      </Box>
                      <Box sx={{mt: 1.5, ml: isAppIimjobs ? 0 : 3.5}}>
                        This contract shall be deemed accepted-without further
                        act or communication-within one working day of: (a) the
                        invoice date for the <i>bill-to</i> customer; (b) the
                        payment date for the <i>paying</i> customer; and (c)
                        subscription activation for the <i>ship-to</i> customer,
                        unless a written objection is submitted to the Company’s
                        finance team within that period.
                      </Box>
                    </>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Info Edge (India) Limited further reserves its right to
                      post the data on the website {DOMAIN} or on such other
                      affiliated sites and publications as Info Edge (India)
                      Limited may deem fit and proper at no extra cost to the
                      subscriber / user.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The subscription / agreement between Info Edge (India)
                      Limited and the subscriber / user is not a &quot;non-poach
                      agreement&quot; nor can the same be termed or used as an
                      alternative to &quot;non-poach agreement&quot; in as much
                      as Info Edge (India) Limited / {DOMAIN} is a public site
                      and all information posted by Info Edge (India) Limited
                      goes to the public domain except information / data which
                      is specifically assigned a non-public / private character.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Any agreement for a subscription / usage entered into Info
                      Edge (India) Limited does not confer exclusivity of
                      service on any subscriber / user.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Info Edge (India) Limited will not be party to any legal
                      proceedings between a user (e.g. a subscriber) and a party
                      contracted through the site. In case Info Edge (India)
                      Limited is implicated in any legal proceedings, costs will
                      be recovered from the party that names Info Edge (India)
                      Limited. Info Edge (India) Limited however will abide with
                      any court order served on it through due process.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      In case a person using the world wide web/internet
                      receives a spam or virus which includes a link to {DOMAIN}{' '}
                      or to any other site maintained, operated or owned by Info
                      Edge (India) Limited, it should not be held responsible
                      for the same. Info Edge (India) Limited assumes no
                      responsibility for such mails.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The services provided by the websites maintained, operated
                      or owned by Info Edge (India) Limited do not extend to
                      acting as an agent (express or implied) on behalf of any
                      subscriber or user.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      Info Edge (India) Limited has no agents and does not
                      operate through any agents save for those specifically
                      mentioned on the home page of the website.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The Terms and conditions mentioned above regulate the
                      usage of&nbsp;{DOMAIN}. Any person using {DOMAIN} in
                      violation of the stipulations contained in the Terms and
                      Conditions of {DOMAIN} shall render himself/herself liable
                      to appropriate action in a court of law both civil and
                      criminal.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      The user of {DOMAIN} is subject to the{' '}
                      <Link href="/privacy" target="_blank">
                        <Typography
                          component={'span'}
                          sx={{
                            color: isAppIimjobs ? 'primary.main' : '#212529',
                            fontWeight: isAppIimjobs ? '400' : 'bolder',
                            fontSize: '14px',
                          }}
                        >
                          Privacy Policy
                        </Typography>
                      </Link>
                      &nbsp;available through this link.
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      In case of non compliance of these Terms and Conditions or
                      Privacy Policy, Info Edge (India) Limited may terminate
                      usage rights and take down any offending information that
                      might have been uploaded by such subscriber/user
                    </Box>
                  }
                />
                <Paragraph
                  style={
                    !isAppIimjobs && {
                      fontSize: '15px',

                      lineHeight: '24px',
                    }
                  }
                  title=""
                  body={
                    <Box display="flex">
                      {!isAppIimjobs && (
                        <Box
                          sx={{
                            pt: 0.5,
                            pr: 1,
                          }}
                        >
                          <Image
                            src={CheckV2}
                            alt="banner-icon"
                            width={20}
                            height={20}
                          />
                        </Box>
                      )}
                      &quot;We as a merchant shall be under no liability
                      whatsoever in respect of any loss or damage arising
                      directly or indirectly out of the decline of authorization
                      for any Transaction, on Account of the Cardholder having
                      exceeded the preset limit mutually agreed by us with our
                      acquiring bank from time to time.&quot;
                    </Box>
                  }
                />
                {isAppIimjobs && (
                  <Paragraph
                    style={
                      !isAppIimjobs && {
                        fontSize: '15px',

                        lineHeight: '24px',
                      }
                    }
                    title=""
                    body={
                      <Box>
                        ADDITIONALLY, BASIS SERVICES CHOSEN, CERTAIN
                        PRODUCT/SERVICE SPECIFIC CONDITIONS MAY APPLY.
                      </Box>
                    }
                  />
                )}
                <Box display="flex">
                  <Box display="flex">
                    {!isAppIimjobs && (
                      <Box
                        sx={{
                          pt: 0.5,
                          pr: 1,
                        }}
                      >
                        <Image
                          src={CheckV2}
                          alt="banner-icon"
                          width={20}
                          height={20}
                        />
                      </Box>
                    )}
                  </Box>
                  <Box>
                    <Paragraph
                      style={
                        !isAppIimjobs && {
                          fontSize: '15px',

                          lineHeight: '24px',
                        }
                      }
                      titleStyle={
                        !isAppIimjobs && {
                          fontSize: '15px',
                          fontWeight: 'bold',
                        }
                      }
                      title="Recruiter Terms"
                      body={
                        <Box>
                          Additional Terms applicable to Recruiters
                          &quot;You&quot; accessing any portion of the website{' '}
                          {DOMAIN}:
                          {isAppIimjobs ? (
                            <ol>{recruiterTeamsContent}</ol>
                          ) : (
                            <Box
                              component={'ul'}
                              sx={{
                                // listStyleType: 'lower-roman',
                                li: {
                                  mt: 0,
                                  '::marker': {
                                    color: theme.palette.primary.main,
                                  },
                                },
                                pl: 1.5,
                              }}
                            >
                              {recruiterTeamsContent}
                            </Box>
                          )}
                        </Box>
                      }
                    />
                  </Box>
                </Box>
                <Box display="flex">
                  <Box display="flex">
                    {!isAppIimjobs && (
                      <Box
                        sx={{
                          pt: 0.5,
                          pr: 1,
                        }}
                      >
                        <Image
                          src={CheckV2}
                          alt="banner-icon"
                          width={20}
                          height={20}
                        />
                      </Box>
                    )}
                  </Box>
                  <Box>
                    <Paragraph
                      style={
                        !isAppIimjobs && {
                          fontSize: '15px',

                          lineHeight: '24px',
                        }
                      }
                      titleStyle={
                        !isAppIimjobs && {
                          fontSize: '15px',
                          fontWeight: 'bold',
                        }
                      }
                      title="Basic/Free Posting"
                      body={
                        <Box>
                          {isAppIimjobs ? (
                            <ol>{basicPostingContent}</ol>
                          ) : (
                            <Box
                              component={'ul'}
                              sx={{
                                // listStyleType: 'lower-roman',
                                li: {
                                  mt: 0,
                                  '::marker': {
                                    color: theme.palette.primary.main,
                                  },
                                },
                                pl: 1.5,
                              }}
                            >
                              {basicPostingContent}
                            </Box>
                          )}
                        </Box>
                      }
                    />
                  </Box>
                </Box>
                <Box display="flex">
                  <Box display="flex">
                    {!isAppIimjobs && (
                      <Box
                        sx={{
                          pt: 0.5,
                          pr: 1,
                        }}
                      >
                        <Image
                          src={CheckV2}
                          alt="banner-icon"
                          width={20}
                          height={20}
                        />
                      </Box>
                    )}
                  </Box>
                  <Box>
                    <Paragraph
                      style={
                        !isAppIimjobs && {
                          fontSize: '15px',

                          lineHeight: '24px',
                        }
                      }
                      titleStyle={
                        !isAppIimjobs && {
                          fontSize: '15px',
                          fontWeight: 'bold',
                        }
                      }
                      title="Signature/Premium Posting"
                      body={
                        <Box>
                          {isAppIimjobs ? (
                            <ol>{signaturePosting}</ol>
                          ) : (
                            <Box
                              component={'ul'}
                              sx={{
                                // listStyleType: 'lower-roman',
                                li: {
                                  mt: 0,
                                  '::marker': {
                                    color: theme.palette.primary.main,
                                  },
                                },
                                pl: 1.5,
                              }}
                            >
                              {signaturePosting}
                            </Box>
                          )}
                        </Box>
                      }
                    />
                  </Box>
                </Box>
                <Box display="flex">
                  <Box display="flex">
                    {!isAppIimjobs && (
                      <Box
                        sx={{
                          pt: 0.5,
                          pr: 1,
                        }}
                      >
                        <Image
                          src={CheckV2}
                          alt="banner-icon"
                          width={20}
                          height={20}
                        />
                      </Box>
                    )}
                  </Box>
                  <Box>
                    <Paragraph
                      style={
                        !isAppIimjobs && {
                          fontSize: '15px',

                          lineHeight: '24px',
                        }
                      }
                      titleStyle={
                        !isAppIimjobs && {
                          fontSize: '15px',
                          fontWeight: 'bold',
                        }
                      }
                      title="Resdex/Database Search"
                      body={
                        <Box>
                          {isAppIimjobs ? (
                            <ol>{resdexContent}</ol>
                          ) : (
                            <Box
                              component={'ul'}
                              sx={{
                                // listStyleType: 'lower-roman',
                                li: {
                                  mt: 0,
                                  '::marker': {
                                    color: theme.palette.primary.main,
                                  },
                                },
                                pl: 1.5,
                              }}
                            >
                              {resdexContent}
                            </Box>
                          )}
                        </Box>
                      }
                    />
                  </Box>
                </Box>
              </>
            }
          />
        </Card>
      </Box>
      {!isAppIimjobs && (
        <Box
          sx={{
            marginBottom: '-64px',
          }}
        >
          <HomePageFooter isTransparent={true} />
        </Box>
      )}
    </Box>
  );
};

export default TermsPage;
